import { render } from "./lastRouletteNumber.vue?vue&type=template&id=29fbc474&scoped=true"
import script from "./lastRouletteNumber.vue?vue&type=script&lang=js"
export * from "./lastRouletteNumber.vue?vue&type=script&lang=js"

import "./lastRouletteNumber.vue?vue&type=style&index=0&id=29fbc474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29fbc474"]])

export default __exports__